import Breadcrumbs from '../components/Breadcrumbs';
import Link from '../components/Link';
import AdSlot from '../components/AdSlot';
import { CONTENT_CLASSES } from '../constants/classNames';
import { ADSENSE_SLOTS, ROUTES } from '../constants/config';
import { CATEGORY_LABELS } from '../constants/effects';
import { getElements } from '../data/sitePages';
import { groupBy } from '../utils/arrayUtils';
import { buildElementPath } from '../utils/routeUtils';
import { joinClassNames } from '../utils/classNameUtils';
import '../styles/ContentPage.css';

/**
 * All 118 elements, grouped by family, each linking to its own page.
 */
export default function ElementsIndexPage() {
  const elementsByCategory = groupBy(getElements(), (element) => element.category);

  return (
    <article className={CONTENT_CLASSES.root}>
      <Breadcrumbs
        trail={[
          { label: 'Lab', path: ROUTES.LAB },
          { label: 'Elements', path: ROUTES.ELEMENTS },
        ]}
      />
      <header className={CONTENT_CLASSES.hero}>
        <h1 className={CONTENT_CLASSES.heading}>The periodic table for kids</h1>
        <p className={CONTENT_CLASSES.lead}>
          Everything around you is made from just 118 elements. Pick one to find out what it is, where you meet it in
          everyday life and what it reacts with.
        </p>
      </header>

      {Object.entries(elementsByCategory).map(([category, elements]) => (
        <section key={category} className={CONTENT_CLASSES.section}>
          <h2 className={CONTENT_CLASSES.sectionTitle}>{CATEGORY_LABELS[category]}</h2>
          <ul className={CONTENT_CLASSES.cardGrid}>
            {elements.map((element) => (
              <li key={element.id}>
                <Link
                  to={buildElementPath(element)}
                  className={joinClassNames(CONTENT_CLASSES.card, `${CONTENT_CLASSES.categoryPrefix}${category}`)}
                >
                  <span className={CONTENT_CLASSES.cardSymbol}>{element.symbol}</span>
                  <span className={CONTENT_CLASSES.cardName}>{element.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      ))}

      <AdSlot slotId={ADSENSE_SLOTS.PAGE_BOTTOM} />
    </article>
  );
}
